/**
 * Client-safe game registry — display info and latency-measurement regions only.
 *
 * Sensitive fields (AWS resource IDs, launch args) live in src/server/games.ts
 * and are never bundled into the client.
 */

export interface GameConfig {
  /** Display name shown in the title bar and landing page */
  name: string;
  /** Regions where the stream group has GPU capacity (for latency measurement) */
  streamLocations: string[];
}

export const GAMES: Record<string, GameConfig> = {
  pressurepoint: {
    name: "Pressure Point",
    streamLocations: [
      "eu-central-1",
      "us-east-1",
      "us-east-2",
      "us-west-2",
      "ap-northeast-1",
    ],
  },
  tob: {
    name: "The Oversight Bureau",
    streamLocations: [
      "eu-central-1",
      "us-east-1",
      "us-east-2",
      "us-west-2",
      "ap-northeast-1",
    ],
  },
};

export type GameSlug = keyof typeof GAMES;
